<template>
<section class="w1312 main-content-wrap">
  <section class="course-container clearfix">
    <div class="lefter-container">
      <ul>
        <li class="active">
          <dl class="clearfix">
            <dt></dt>
            <dd>
              <span>课程</span>
              <br/>
              {{courseDetail.title}}
            </dd>
          </dl>
        </li>
        <li v-for="(item, index) in (courseDetail && courseDetail.chapterOverviews || [])" :key="index" @click="goChapter(item)" mars_sead="vschool_courselanding_chapter_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'courseId': item.courseId, 'chapterId': item.chapterId })">
          <dl class="clearfix">
            <dt></dt>
            <dd>
              <span>
                <i :class="{'c-finish': true}" v-if="item.studied === 1">(已完成)</i>
                <i :class="{'c-unfinish': true}" v-if="item.studied === 0">(待完成)</i>
                章节{{index + 1}}
              </span>
              <br/>
              {{item.title}}
            </dd>
          </dl>
        </li>
        <!--lastExamResult 上次考试结果，0-未考过、1-及格、2-不及格 -->
        <li v-for="(item, index) in (examOfCourseList || [])" :key="index">
          <dl class="clearfix">
            <dt></dt>
            <dd class="exam-list">
              <template v-if="item.times === 1">
                <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="!deadlineTimeout(item.deadline) && item.examUrl && item.lastExamResult === 0">
                  <span>
                    <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                    <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                    考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                  </span>
                  <br/>
                  {{item.title}}
                </a>
                <a :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult === 2 || item.lastExamResult === 1 || deadlineTimeout(item.deadline))">
                  <span>
                    <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                    <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                    考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                  </span>
                  <br/>
                  {{item.title}}
                </a>
              </template>
              <template v-else-if="item.times === 999">
                <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="!deadlineTimeout(item.deadline) && item.examUrl && (item.lastExamResult === 0 || item.lastExamResult === 2)">
                  <span>
                    <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                    <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                    考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                  </span>
                  <br/>
                  {{item.title}}
                </a>
                <a :href="item.analysisUrl" class="button" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult === 1 || deadlineTimeout(item.deadline))">
                  <span>
                    <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                    <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                    考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                  </span>
                  <br/>
                  {{item.title}}
                </a>
              </template>
              <template v-else>
                <template v-if="!deadlineTimeout(item.deadline) && (item.lastExamResult === 0 || (item.lastExamResult === 2 && item.makeupCount))">
                  <a :href="item.examUrl" class="button" target="_blank" title="开始答题" v-if="item.examUrl">
                    <span>
                      <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                      <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                      考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                    </span>
                    <br/>
                    {{item.title}}
                  </a>
                </template>
                <template v-else>
                  <a :href="item.analysisUrl" class="button info" target="_blank" title="答题解析" v-if="item.analysisUrl && (item.lastExamResult === 2 || item.lastExamResult === 1)">
                    <span>
                      <i :class="{'c-finish': true}" v-if="item.lastExamResult === 1">(已完成)</i>
                      <i :class="{'c-unfinish': true}" v-else>(待完成)</i>
                      考试{{examOfCourseList.length > 1 ? index + 1 : ''}}
                    </span>
                    <br/>
                    {{item.title}}
                  </a>
                </template>
              </template>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
    <div class="righter-container">
      <div class="right-content">
        <div class="bread-crumb">
          <a href="javascript:;" @click="goBack()" class="c-666">返回</a>
          &gt;
          {{courseDetail.title}}
        </div>
        <view-container :loading="loading" :empty="empty" :error="error" @retry="loadData">
          <div>
            <div class="notice-wrap">
              <div class="course-wrap clearfix">
                <div class="course-lefter">
                  <div class="course-title">
                    {{courseDetail.title}}
                  </div>
                  <div class="course-desc">
                    {{courseDetail.chapterOverviews && courseDetail.chapterOverviews.length || 0}}章节 | 时长：{{parseDuration(courseDetail.duration)}}
                  </div>
                  <div class="course-show">
                    <a href="javascript:;" @click="goChapter() & $send('vschool_courselanding_clicktoview_buttonclick', {'sessionTarget': sessionTarget})" class="course-button">
                      立即查看
                    </a>
                  </div>
                  <div class="like-container">
                    <button :class="{'active': courseDetail.liked === 1}" @click="handlerState(1)" mars_sead="vschool_courselanding_likestate_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})">
                      <i></i>有 用
                    </button>
                    <button :class="{'active': courseDetail.liked === 0}" @click="handlerState(0)" mars_sead="vschool_courselanding_likestate_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})">
                      <i></i>没 用
                    </button>
                  </div>
                </div>
                <div class="course-righter">
                  <imgWrap :src="courseDetail.coverUrl" width="398" height="260" :alt="courseDetail.title" :item="courseDetail" :pic="'coverUrl'"/>
                </div>
              </div>
            </div>

            <div class="notice-wrap course-content" v-html="courseDetail.richText">
            </div>
          </div>
        </view-container>

      </div>

    </div>
    <t-dialog v-model:visible="visible" :closeBtn="false" :footer="false" :closeOnOverlayClick="true" :closeOnEscKeydown="false">
      <div class="text-center">
        <img :src="lockPic" width="350" height="200"/>
        <p class="warning-title">
          抱歉，暂无查看权限
        </p>
        <p class="warning-desc" v-if="(userInfo.username || userInfo.avatarUrl) && !courseDetail.privileged">{{`该账号无权限查看此课程，请退出再使用${sessionTarget === 1 ? '商家' : '供应商'}或员工手机号登录的唯品会APP重新扫码`}}</p>
        <p class="warning-desc" v-else>{{sessionTarget === 1 ? '此课程仅开放给商家和唯品会员工查看，请使用唯品会APP扫码登录' : '此课程仅开放给供应商和唯品会员工查看，请使用唯品会APP扫码登录'}}</p>
        <p class="warning-button">
          <a href="javascript:;" v-if="(userInfo.username || userInfo.avatarUrl) && !courseDetail.privileged" mars_sead="vschool_courselanding_login_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})" @click="loginOut()">
            退 出
          </a>
          <a :href="`https://passport.vip.com/login?src=${locationHref}`" title="使用供应商账号登录" mars_sead="vschool_courselanding_login_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})" v-else>
            登 录
          </a>
        </p>
      </div>
    </t-dialog>
  </section>
</section>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import lockPic from '../../assets/img/lock-pic.png'
import util from '@/util/index.js'
import imgWrap from '@/components/imgWrap'
import {clearCookies} from '@/lib'
import mixins from '../examCenter/mixins'
export default {
  name: '',
  mixins: [mixins],
  data () {
    return {
      locationHref: window.encodeURIComponent(window.location.href),
      courseId: 0,
      visible: false,
      lockPic,
      loading: false,
      error: false,
      empty: false
    }
  },
  computed: {
    ...mapState(['courseDetail', 'sessionTarget', 'primaryCategoryId', 'queryUserPromise', 'userInfo', 'examOfCourseList'])
  },
  mounted () {
    this.queryUserPromise.then(() => {
      const {
        courseId
      } = this.$route.params
      this.courseId = Number(courseId)
      this.loadData()
    })
  },
  methods: {
    loadData () {
      if (this.courseDetail.courseId !== this.courseId) {
        this.loading = true
        this.error = false
        this.queryByCourseId(this.courseId)
        this.queryCourseDetail(this.courseId).catch(() => {
          this.error = true
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.queryCourseDetail(this.courseId)
        setTimeout(() => {
          this.updatePrimaryCategoryId(this.courseDetail.primaryCategoryId)
        }, 10)
      }
    },
    goChapter (item) {
      let target = item
      if (!item) {
        target = this.courseDetail.chapterOverviews && this.courseDetail.chapterOverviews[0]
      }
      if (!this.courseDetail.privileged) {
        this.visible = true
        return // this.$message.warning('对不起，当前无权限下查看此详情')
      }
      this.$router.push({
        name: 'ChapterDetail',
        params: {
          'courseId': this.courseDetail.courseId,
          'chapterId': target.chapterId,
          'target': this.sessionTarget
        }
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    handlerState (state) {
      if (!this.courseDetail.privileged) {
        this.visible = true
        return
      }
      if (this.courseDetail.liked === state) {
        this.like({
          courseId: this.courseId,
          likeOrNot: null
        }).then(() => {
          this.courseDetail.liked = null
          this.$message.success('操作成功')
        })
      } else {
        this.like({
          courseId: this.courseId,
          likeOrNot: state
        }).then(() => {
          this.courseDetail.liked = state
          this.$message.success('操作成功')
        })
      }
      this.loadData()
    },
    download (url) {
      let $a = document.createElement('a')
        $a.setAttribute('href', url)
        $a.setAttribute('target', '_blank')
        // $a.setAttribute('download', `${this.title}-${this.moment(this.operationTimestamp)}.jpeg`);
        let fileLink = document.createElement('span')
        fileLink.setAttribute('style', 'cursor: pointer; -webkit-tap-highlight-color: transparent')
        $a.appendChild(fileLink)
        let body = document.getElementsByTagName('body')[0]
        body.appendChild($a)
        fileLink.click()
        body.removeChild($a)
    },
    loginOut () {
      this.signout().then(() => {
        clearCookies()
        let src = `https://passport.vip.com/login?src=${this.locationHref}`
        window.location.href = src
        // window.location.href = `https://passport.vip.com/logout?src=${window.encodeURIComponent(this.locationHref)}`
      })
    },
    ...mapMutations(['updatePrimaryCategoryId']),
    ...mapActions(['queryCourseDetail', 'like', 'signout', 'queryByCourseId']),
    parseDuration: util.parseDuration
  },
  components: {
    imgWrap
  }
}
</script>

<style lang="scss" scoped>
.bread-crumb {
  font-size: 16px;
  color: #999;
  padding: 20px 36px;
}
.notice-wrap {
  background: #fff;
  padding: 13px 36px;
}
.course-wrap {
  border-bottom: 1px solid #E7E7E7;
  padding-bottom: 50px;
  display: flex;
  .course-lefter {
    flex: 1;
    width: 505px;
    min-width: 505px;
    position: relative;
    .course-title {
      font-size: 24px;
      color: #333;
    }
    .course-desc {
      font-size: 16px;
      color: #666;
      margin-top: 12px;
    }
    .course-show {
      margin-top: 30px;
      .course-button {
        display: inline-block;
        background: #FD3374;
        width: 104px;
        height: 34px;
        border-radius: 20px;
        color: #fff;
        font-size: 14px;
        text-align: center;
        line-height: 34px;
      }
      a:hover {
        text-decoration: none;
      }
    }
    .like-container {
      position: absolute;
      bottom: 0;
      font-size: 14px;
      button {
        line-height: 30px;
        border: 1px solid #D3D6DA;
        margin-right: 22px;
        padding: 0 16px;
        border-radius: 30px;
        color: #666;
        cursor: pointer;
        outline: none;
        background: transparent;
        &:first-child {
          i {
            display: inline-block;
            width: 18px;
            height: 18px;
            background: url(../../assets/img/bg-like.png) no-repeat 1px 1px;
            background-size: 16px;
            vertical-align: middle;
            position: relative;
            top: -2px;
            margin-right: 5px;
          }
        }
        &:nth-child(2) {
          i {
            display: inline-block;
            width: 18px;
            height: 18px;
            background: url(../../assets/img/bg-unlike.png) no-repeat 1px 1px;
            background-size: 16px;
            vertical-align: middle;
            position: relative;
            top: -2px;
            margin-right: 5px;
          }
        }
        &.active, &:hover {
          border: 1px solid #FD3374;
          color: #FD3374;
          &:first-child {
            i {
              background: url(../../assets/img/bg-linked.png) no-repeat 1px 1px;
              background-size: 16px;
            }
          }
          &:nth-child(2) {
            i {
              background: url(../../assets/img/bg-unliked.png) no-repeat 1px 1px;
              background-size: 16px;
            }
          }
        }
      }
    }
  }
  .course-righter  {
    flex: 1;
    width: 398px;
    max-width: 398px;
    height: 260px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 8px #e7e7e7;
    border: 1px solid #e7e7e7;
    img {
    }
  }
}
.course-content {
  font-size: 16px;
  color: #333;
  a, a:link, a:active, a:visited {
    color: #157DF9;
  }
}
.course-container {
  margin-top: 25px;
  display: flex;
  .lefter-container {
    // float: left;
    width: 296px;
    max-width: 296px;
    max-height: 500px;
    background: #fff;
    border-radius: 8px;
    padding: 32px 32px;
    margin-bottom: 25px;
    position: sticky;
    top: 0;
    overflow-y: auto;
    align-self: flex-start;
    box-sizing: border-box;
    .lefter-title {
      font-size: 18px;
      font-weight: bold;
      margin-top: 32px;
    }
    ul {
      li {
        font-size: 16px;
        position: relative;
        background: url(../../assets/img/line-bg.png) repeat-y 12px 0;
        line-height: 20px;
        padding-bottom: 65px;
        cursor: pointer;
        &:last-child {
          padding-bottom: 0;
          background: none;
        }
        &:hover {
          dl {
            dd {
              color: #FD3374;
            }
          }
        }
        .nav-icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../assets/img/nav-icon.png) no-repeat;
          margin-top: 5px;
        }
        .iconfont, /deep/ .iconfont {
          position: absolute;
          right: 0;
          top: 6px;
          z-index: 1;
        }
        &:first-child {
          dl {
            dt {
              background: url(../../assets/img/book-icon.png) no-repeat;
            }
          }
        }
        dl {
          display: flex;
          dt {
            flex: 1;
            background: url(../../assets/img/circle-icon.png) no-repeat 5px 0;
            width: 38px;
            max-width: 38px;
            height: 24px;
          }
          dd {
            flex: 1;
            font-size: 14px;
            color: #666;
            span {
              font-size: 12px;
              color: #999;
            }
          }
        }
        &.active {
          dl {
            dt {}
            dd {
              color: #FD3374;
            }
          }
        }
      }
    }
  }
  .righter-container {
    // float: left;
    flex: 1;
    width: 976px;
    min-width: 976px;
    padding-left: 35px;
    margin-bottom: 25px;
    .right-content {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      min-height: 500px;
    }
    .recommend-container {
      .tab-container {
        text-align: right;
        margin-top: 0;
        ul {
          text-align: right;
          li {
            font-size: 14px;
            border: 1px solid #ccc;
            margin: 0;
            width: 68px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            margin-left: -1px;
            color: #666;
            cursor: pointer;
            &.active {
              border: 1px solid #FD3374;
              color: #FD3374;
              position: relative;
              z-index: 1;
              background: #fff;
            }
            &:first-child {
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
            }
            &:last-child {
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
            }
          }
        }
      }
      .list-container {
        margin-top: 20px;
      }
    }
  }
}
.warning-title {
  font-size: 16px;
  color: #666;
  font-weight: 600;
  margin-top: 10px;
}
.warning-desc {
  font-size: 16px;
  color: #999;
  margin-top: 20px;
}
.warning-button  {
  margin-top: 30px;
  margin-bottom: 40px;
  button, a {
    display: inline-block;
    background: #FD3374;
    color: #fff;
    outline: none;
    border: 0;
    line-height: 42px;
    height: 42px;
    width: 184px;
    border-radius: 5px;
    font-size: 16px;
  }
}
</style>
